// Copyright Caproc Oy
// System name: Aqua-Net 
// System module: Sensor
// Author: TS
//
// 19.3.2020 TS Initial version
// 28.3.2020 TS Added Alarm status to sensor if any of the variables has High Alarm or Low Alarm.
// 15.6.2020 TS Changed date created to device address in sensors list. text align to "center" for alarm status ok.
// 27.6.2020 TS Added link alarms list if alarm activated
// 06.02.2021 TS Measure interval * 2 in check if online
// 18.02.2021 TS Changes to table
// 7.3.2021 TS Added sensor group display value
// 4.8.2021 TS Increased sensor "Offline" limit to 3 x measure interval
// 14.7.2022 TS Added admin info to status
// 18.8.2023 TS Added Cellular to network status Popup. Status now available to all.
// 7.1.2024 1.0.8 TS Polygon texts and titles
// 6.4.2026 TS (claude) Added table view with bulk actions (move to group, move to company, archive/activate, delete)
// 7.4.2026 TS (claude) Unified table view Active/Archive filter to use the same Menu tabs as the grouped view (shared activeMenuItem state)
// 7.4.2026 TS (claude) Removed device thumbnail image column from table view
// 7.4.2026 TS (claude) Extended table view search to cover sensor group, device name/eui, location address and last value
// 7.4.2026 TS (claude) Polygon: display "Default group" as "TMP VARASTO" in table view sensor group column and dropdowns
// 7.4.2026 TS (claude) Default table view sensor group filter to "all" so all sensors are shown on first open
// 7.4.2026 TS (claude) Added bulk action "Edit address" with Google Places autocomplete to update device location for selected sensors
// 7.4.2026 TS (claude) Restricted bulk Delete action in archived view to A/S roles only
// 7.4.2026 TS (claude) Added bulk action "Clear address" to wipe device location fields with confirmation
// 7.4.2026 TS (claude) Fixed bulk Clear address 500 error: latitude/longitude are FloatFields, send 0 instead of empty string
// 7.4.2026 TS (claude) Reset table view sensor group filter to "all" when active company changes, and refetch the sensor list
// 7.4.2026 TS (claude) Validate tableGroupFilter against freshly fetched groups; reset to "all" if the stored group id no longer exists
// 7.4.2026 TS (claude) Fixed eslint array-callback-return warning by adding null fallthrough in sensors map
// 7.4.2026 TS (claude) Show table view bulk action bar and selection checkboxes to all roles; Move to company / Archive / Activate / Delete still restricted to A or S
// 7.4.2026 TS (claude) Hide table view bulk actions and selection checkboxes from users with only the Client (C) role
// 8.4.2026 TS (claude) Use startsWith for CAPROC-TH-PROBE-3 model check so CAPROC-TH-PROBE-3-C variants get the multi-value last status display
// 8.4.2026 TS (claude) Table view: collapse Status / Alarms / Active columns to header-text width (icon-only data)
// 8.4.2026 TS (claude) Sort bulk action "Move to company" company options alphabetically (fi locale)
// 8.4.2026 TS (claude) Sort sensor groups: Default group first, then alphabetically (fi locale) — applied to grouped view, table filter and bulk Move to group
// 8.4.2026 TS (claude) Table view: show selected sensor group's name, description and address as a link to SensorGroupDetails next to the filter dropdown
// 20.4.2026 TS (claude) Added "Signal" column after "Alarms" in table view: phone-style signal bars from LoRa SNR / Cellular RSRP, with hover popup showing raw values and quality class
// 20.4.2026 TS (claude) Enlarged signal bars (heights 7/13/19/25, width 5px, gap 2px) for better visibility and clearer differentiation between levels
// 20.4.2026 TS (claude) Added "Signal" column to grouped view as well (after Alarms in both Polygon and default header branches)

import React from "react";
import { Message, Header, Button, Table, Segment, Dimmer, Loader, Image, Menu, Confirm, Input, Icon, Popup, Responsive, Grid, Checkbox, Select} from "semantic-ui-react";
import Shell from "./Shell";
import { authAxios, getWidth, exportToCsv  } from "../../utils";
import { setActivity } from "../../store/actions/auth";
import { withRouter, Link, Redirect } from "react-router-dom";
import { connect } from "react-redux";
import { withTranslation } from 'react-i18next';
import { fetchSensorGroupsURL, deleteSensorDetailsURL, sensorGroupAlarmNotificationChangeURL, sensorsUpdateMultipleURL, sensorsDeleteMultipleURL, sensorMoveToOtherCompanyURL } from "../../constants";
import AddressAutocomplete from "./AddressAutocomplete";
  

class Sensors extends React.Component {
    state = {
        sensor_groups: null,
        activeMenuItem: this.props.t("Active"),
        delete_confirm_open: false,
        delete_confirm_text: "",
        delete_item: "",
        active_sensor: null,
        error: null,
        loading: false,
        success_mgs: null,
        activeIndex: 0,
        activeIndex2: 0,
        search: "",
        viewMode: localStorage.getItem("sensorViewMode") || "grouped",
        selectedSensorIds: new Set(),
        selectAll: false,
        sortColumn: null,
        sortDirection: null,
        tableGroupFilter: JSON.parse(localStorage.getItem("sensorTableGroupFilter")) || "all",
        bulkActionLoading: false,
        bulkMoveGroupId: null,
        bulkMoveCompanyId: null,
        bulkAddress: "",
        bulkPostalCode: "",
        bulkCity: "",
        bulkCountry: "",
        bulkLatitude: "",
        bulkLongitude: "",
        bulkAction: null,
        bulk_confirm_open: false,
        bulk_confirm_text: "",
        bulk_confirm_action: null
    };

    componentDidMount() {
        this.props.setActivity();
        this.handleFetchGroupList();
        if (localStorage.getItem("sensorTableGroupFilter") === null) {
            localStorage.setItem("sensorTableGroupFilter", JSON.stringify("all"));
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.activeCompanyId !== this.props.activeCompanyId) {
            localStorage.setItem("sensorTableGroupFilter", JSON.stringify("all"));
            this.setState({
                tableGroupFilter: "all",
                selectedSensorIds: new Set(),
                selectAll: false
            });
            this.handleFetchGroupList();
        }
    }

    handleFetchGroupList = () => {
        this.setState({
            loading: true
        });
        const { activeCompanyId } = this.props;
        authAxios
            .get(fetchSensorGroupsURL(activeCompanyId))
            .then(res => {
                const { tableGroupFilter } = this.state;
                const validIds = (res.data || []).map(g => g.id);
                const filterValid = tableGroupFilter === "all" || validIds.includes(tableGroupFilter);
                if (!filterValid) {
                    localStorage.setItem("sensorTableGroupFilter", JSON.stringify("all"));
                }
                this.setState({
                    sensor_groups: res.data,
                    tableGroupFilter: filterValid ? tableGroupFilter : "all",
                    error: null,
                    loading: false
                });
            })
            .catch(err => {
                this.setState({
                    loading: false,
                    error: err
                });
            });
    };

    handleDeleteSensor = sensor_id => {
        this.setState({
            loading: true
        });
        const { activeCompanyId } = this.props;
        authAxios
            .delete(deleteSensorDetailsURL(activeCompanyId, sensor_id))
            .then(res => {
                this.setState({
                    error: null,
                    loading: false
                });
                this.handleFetchGroupList();
            })
            .catch(err => {
                this.setState({
                    loading: false,
                    error: err
                });
            });
        this.setState({
            delete_confirm_open: false,
            delete_confirm_text: "",
            delete_item: ""
        });
    };

    sensorDetails = id => {
        this.props.history.push(`/sensor/status-variables/${id}/`)
    };

    handleMenuItemClick = (e, { name }) => this.setState({ activeMenuItem: name });

    openDeleteConfirm = (text, delete_item) => {
        this.setState({
            delete_confirm_open: true,
            delete_confirm_text: text,
            delete_item: delete_item
        });
    };

    closeDeleteConfirm = () => {
        this.setState({
            delete_confirm_open: false,
            delete_confirm_text: "",
            delete_item: ""
        });
    };

    openSensorDetails = sensor => {
        this.sensorDetails(sensor.id);
    };

    openSensorAlarm = sensor => {
        this.props.history.push(`/sensor/alarms/${sensor.id}/`)
    };

    handleGetAlarmsStatus = sensor => {
        const { t } = this.props;
        if (sensor.last_status) {
            let i = 0;
            for (i in sensor.sensorstatusvariables) {
                if (sensor.sensorstatusvariables[i].status.includes("Alarm") && sensor.sensorstatusvariables[i].status !== "Alarm on" && sensor.sensorstatusvariables[i].status !== "Alarm off") {
                    return <Table.Cell error  onClick={() => this.openSensorAlarm(sensor)}><Header as="h5" color="red"><Popup content={t(sensor.sensorstatusvariables[i].status)} trigger={<Icon name="attention" />} /></Header></Table.Cell>
                }
            }
            const sensor_last_status_sec = new Date(sensor.last_status).getTime() / 1000;
            const current_time_sec = new Date().getTime() / 1000;
            if ((current_time_sec - sensor_last_status_sec) > sensor.measure_interval * 3) {
                return <Table.Cell textAlign="center"  onClick={() => this.openSensorDetails(sensor)}><Header as="h5" color="red"><Popup content={t("Offline")} trigger={<Icon name="attention" />} /> </Header></Table.Cell>
            } else {
                return <Table.Cell  textAlign="center"  onClick={() => this.openSensorDetails(sensor)}><Header as="h5" color="green"><Popup content={t("No alarms")} trigger={<Icon name="check circle outline" />} /></Header></Table.Cell>
            }
        } else {
            return <Table.Cell  textAlign="center"  onClick={() => this.openSensorDetails(sensor)}><Header as="h5" color="red"><Popup content={t("Offline")} trigger={<Icon name="attention" />} /></Header></Table.Cell>
        }
    };

    isSensorOffline = sensor => {
        if (!sensor.last_status) return true;
        const last_sec = new Date(sensor.last_status).getTime() / 1000;
        const now_sec = new Date().getTime() / 1000;
        return (now_sec - last_sec) > sensor.measure_interval * 3;
    };

    getSignalLevel = sensor => {
        if (this.isSensorOffline(sensor)) return null;
        if (sensor.device_type === "L") {
            if (!sensor.last_lrc || sensor.last_lrc === "") return null;
            const snr = sensor.last_snr;
            if (snr > 0) return 4;
            if (snr >= -7) return 3;
            if (snr >= -15) return 2;
            return 1;
        } else {
            if (!sensor.cell_id || sensor.cell_id === 0) return null;
            const rsrp = sensor.rsrp;
            if (rsrp >= -80) return 4;
            if (rsrp >= -90) return 3;
            if (rsrp >= -100) return 2;
            return 1;
        }
    };

    renderSignalCell = sensor => {
        const { t } = this.props;
        const is_desktop = getWidth() > Responsive.onlyMobile.maxWidth;
        const level = this.getSignalLevel(sensor);
        const mobile_label = !is_desktop && (<React.Fragment><b>{t("Signal")}</b><br/></React.Fragment>);

        if (level === null) {
            return (
                <Table.Cell collapsing textAlign="center" onClick={() => this.openSensorDetails(sensor)}>
                    {mobile_label}
                    <Popup content={t("No signal data")} trigger={<span style={{ color: "#bbb", fontSize: "1.5em" }}>—</span>} />
                </Table.Cell>
            );
        }

        const quality_label = level >= 4 ? t("Excellent") : level === 3 ? t("Good") : level === 2 ? t("Moderate") : t("Weak");
        const filled_color = level >= 3 ? "#21ba45" : level === 2 ? "#f2711c" : "#db2828";
        const bar_heights = [7, 13, 19, 25];
        const bars = bar_heights.map((h, idx) => (
            <span
                key={idx}
                style={{
                    display: "inline-block",
                    width: "5px",
                    height: `${h}px`,
                    background: idx < level ? filled_color : "#d4d4d5",
                    borderRadius: "1px"
                }}
            />
        ));
        const bars_wrapper = (
            <span style={{ display: "inline-flex", alignItems: "flex-end", gap: "2px", height: "25px", verticalAlign: "middle" }}>
                {bars}
            </span>
        );

        let popup_content;
        if (sensor.device_type === "L") {
            popup_content = `SNR: ${sensor.last_snr}  RSSI: ${sensor.last_rssi}  SF: ${sensor.last_sf}  (${quality_label})`;
        } else {
            popup_content = `RSRP: ${sensor.rsrp}  ${t("Network")}: ${sensor.network_mode}  (${quality_label})`;
        }

        return (
            <Table.Cell collapsing textAlign="center" onClick={() => this.openSensorDetails(sensor)}>
                {mobile_label}
                <Popup content={popup_content} trigger={bars_wrapper} />
            </Table.Cell>
        );
    };

    handleGetStatus = sensor => {
        const { t } = this.props;
        if (sensor.last_status) {
            const sensor_last_status_sec = new Date(sensor.last_status).getTime() / 1000;
            const current_time_sec = new Date().getTime() / 1000;
            if ((current_time_sec - sensor_last_status_sec) > sensor.measure_interval * 3) {
                if (this.props.activeRoles && this.props.activeRoles.includes("A"))
                    return <Table.Cell textAlign="center"  onClick={() => this.openSensorDetails(sensor)}><Header as="h5" color="red"><Popup content={t("Offline") + " " + sensor.last_rssi + " " + sensor.last_sf + " " + sensor.last_lrc} trigger={<Icon name="attention" />} /> </Header></Table.Cell>
                else
                    return <Table.Cell textAlign="center"  onClick={() => this.openSensorDetails(sensor)}><Header as="h5" color="red"><Popup content={t("Offline")} trigger={<Icon name="attention" />} /> </Header></Table.Cell>
            } else {
                // if (this.props.activeRoles && this.props.activeRoles.includes("A"))
                //     return <Table.Cell textAlign="center"  onClick={() => this.openSensorDetails(sensor)}><Header as="h5" color="green"><Popup content={t("Online") + " " + sensor.last_rssi + " " + sensor.last_sf + " " + sensor.last_lrc} trigger={<Icon name="check circle outline" />} /></Header></Table.Cell>
                // else
                //     return <Table.Cell textAlign="center"  onClick={() => this.openSensorDetails(sensor)}><Header as="h5" color="green"><Popup content={t("Online")} trigger={<Icon name="check circle outline" />} /></Header></Table.Cell>
                // LoRaWAN device
                if (sensor.device_type === "L")
                {
                    return <Table.Cell textAlign="center"  onClick={() => this.openSensorDetails(sensor)}><Header as="h5" color="green"><Popup content={t("Online") + " " + sensor.last_rssi + " " + sensor.last_sf + " " + sensor.last_lrc} trigger={<Icon name="check circle outline" />} /></Header></Table.Cell>
                }
                else
                {
                    return <Table.Cell textAlign="center"  onClick={() => this.openSensorDetails(sensor)}><Header as="h5" color="green"><Popup content={t("Online") + " " + sensor.network_mode + " " + sensor.rsrp + " " + sensor.mccmnc + " " + sensor.cell_id} trigger={<Icon name="check circle outline" />} /></Header></Table.Cell>
                }
            }
        } else {
            return <Table.Cell textAlign="center"  onClick={() => this.openSensorDetails(sensor)}><Header as="h5" color="red"><Popup content={t("Offline")} trigger={<Icon name="attention" />} /></Header></Table.Cell>
        }
    }

    handleGetFilterList = sensors => {
        const { search } = this.state;
        let filtered_list = [];
        filtered_list = sensors.filter((sensor) => {
            return sensor.local_machine.toLowerCase().indexOf(search.toLocaleLowerCase()) !== -1 ||
                sensor.local_name.toLowerCase().indexOf(search.toLocaleLowerCase()) !== -1 ||
                sensor.model_name.toLowerCase().indexOf(search.toLocaleLowerCase()) !== -1 ||
                sensor.device_address.toLowerCase().indexOf(search.toLocaleLowerCase()) !== -1 ||
                sensor.local_unit.toLowerCase().indexOf(search.toLocaleLowerCase()) !== -1 ||
                sensor.local_line.toLowerCase().indexOf(search.toLocaleLowerCase()) !== -1;

        })
        return filtered_list;
    };

    handleGetTableFilterList = sensors => {
        const { search } = this.state;
        const q = (search || "").toLocaleLowerCase();
        if (!q) return sensors;
        const fields = [
            "local_machine", "local_name", "model_name", "device_address",
            "local_unit", "local_line", "device_name", "device_eui",
            "sensor_group_name", "last_display_value",
            "device_location_address", "device_location_postal_code", "device_location_city"
        ];
        return sensors.filter((sensor) => {
            return fields.some((f) => {
                const v = sensor[f];
                return v && String(v).toLocaleLowerCase().indexOf(q) !== -1;
            });
        });
    };

    handleChange = e => {
        this.setState({
            [e.target.name]: e.target.value
        });
    };

    handleGetFilterListToExport = sensor_groups => {
        let i = 0;
        let x = 0;
        let sensors = [];
        for (i in sensor_groups) {
            for (x in sensor_groups[i].sensors) {
                sensors.push(sensor_groups[i].sensors[x]);
            }
        }
        return this.handleGetFilterList(sensors);
    };

    handleGroupNotificationChange = sensor_group_id => {
        this.setState({
            loading: true
        });
        const { activeCompanyId } = this.props;
        authAxios
            .post(sensorGroupAlarmNotificationChangeURL(activeCompanyId, sensor_group_id))
            .then(res => {
                this.setState({
                    error: null,
                    loading: false
                });
                this.handleFetchGroupList();
            })
            .catch(err => {
                this.setState({
                    loading: false,
                    error: err
                });
            });
    }

    handleLastStatusDisplay = (sensor, row) => {
        //const { t } = this.props;
        let disp_value = "";
        let title = "";
        let i = 0;
        for (i in sensor.sensorstatusvariables) {
            if (sensor.sensorstatusvariables[i].is_active && sensor.sensorstatusvariables[i].is_display_value)
            {
                if (row === 1)
                {
                    if (sensor.sensorstatusvariables[i].name === "Corrected temperature TH probe" ||
                        sensor.sensorstatusvariables[i].name === "Temperature TH Probe" || 
                        sensor.sensorstatusvariables[i].name === "Corrected humidity TH probe" ||
                        sensor.sensorstatusvariables[i].name === "Humidity TH Probe")
                    {
                        if (disp_value === "")
                        {
                            disp_value = sensor.sensorstatusvariables[i].last_value + sensor.sensorstatusvariables[i].measurement_unit;
                        }
                        else
                        {
                            disp_value = disp_value + " " + sensor.sensorstatusvariables[i].last_value + sensor.sensorstatusvariables[i].measurement_unit;
                        }

                        if (title === "" && sensor.sensorstatusvariables[i].display_name.includes("concrete A"))
                        {
                            title = " - Betoni A";
                        }
                        else if (title === "" && sensor.sensorstatusvariables[i].display_name.includes("concrete B"))
                        {
                            title = " - Betoni B";
                        }
                        else if (title === "" && sensor.sensorstatusvariables[i].display_name.includes("air"))
                        {
                            title = " - Sisäilma";
                        }
                    }
                }
                else if (row === 2)
                {
                    if (sensor.sensorstatusvariables[i].name === "Corrected temperature TH probe 2" ||
                        sensor.sensorstatusvariables[i].name === "Temperature TH Probe 2" || 
                        sensor.sensorstatusvariables[i].name === "Corrected humidity TH probe 2" ||
                        sensor.sensorstatusvariables[i].name === "Humidity TH Probe 2")
                    {
                        if (disp_value === "")
                        {
                            disp_value = sensor.sensorstatusvariables[i].last_value + sensor.sensorstatusvariables[i].measurement_unit;
                        }
                        else
                        {
                            disp_value = disp_value + " " + sensor.sensorstatusvariables[i].last_value + sensor.sensorstatusvariables[i].measurement_unit;
                        }

                        if (title === "" && sensor.sensorstatusvariables[i].display_name.includes("concrete A"))
                        {
                            title = " - Betoni A";
                        }
                        else if (title === "" && sensor.sensorstatusvariables[i].display_name.includes("concrete B"))
                        {
                            title = " - Betoni B";
                        }
                        else if (title === "" && sensor.sensorstatusvariables[i].display_name.includes("air"))
                        {
                            title = " - Sisäilma";
                        }
                    }
                }
                else if (row === 3)
                {
                    if (sensor.sensorstatusvariables[i].name === "Corrected temperature TH probe 3" ||
                        sensor.sensorstatusvariables[i].name === "Temperature TH Probe 3" || 
                        sensor.sensorstatusvariables[i].name === "Corrected humidity TH probe 3" ||
                        sensor.sensorstatusvariables[i].name === "Humidity TH Probe 3")
                    {
                        if (disp_value === "")
                        {
                            disp_value = sensor.sensorstatusvariables[i].last_value + sensor.sensorstatusvariables[i].measurement_unit;
                        }
                        else
                        {
                            disp_value = disp_value + " " + sensor.sensorstatusvariables[i].last_value + sensor.sensorstatusvariables[i].measurement_unit;
                        }
                        if (title === "" && sensor.sensorstatusvariables[i].display_name.includes("concrete A"))
                        {
                            title = " - Betoni A";
                        }
                        else if (title === "" && sensor.sensorstatusvariables[i].display_name.includes("concrete B"))
                        {
                            title = " - Betoni B";
                        }
                        else if (title === "" && sensor.sensorstatusvariables[i].display_name.includes("air"))
                        {
                            title = " - Sisäilma";
                        }
                    }
                }
            }
        }
        if (disp_value !== "")
        {
            if (row === 1)
            {
                if (title !== "")
                {
                    disp_value = disp_value + title;
                }
                else
                {
                    disp_value = disp_value + " - Sisäilma";
                }
            }
            else if (row === 2)
            {
                if (title !== "")
                {
                    disp_value = disp_value + title;
                }
                else
                {
                    disp_value = disp_value + " - Pinta";
                }
            }
            else if (row === 3)
            {
                if (title !== "")
                {
                    disp_value = disp_value + title;
                }
                else
                {
                    disp_value = disp_value + " - Arviointi";
                }
            }
        }
        else
        {
            disp_value = sensor.last_display_value;
        }
        return disp_value;
    }

    handleExportToCSV = items => {
        const { t } = this.props;
        if (items !== null) {
            const titles = [
                t("Local unit"),
                t("Local line"),
                t("Local machine"),
                t("Local name"),
                t("Model name"),
                t("Device name"),
                t("UUID"),
                t("Device description"),
                t("Device address"),
                t("Device EUI"),
                t("Last status"),
                t("Measure Interval"),
                t("Date created"),
                t("Last modified"),
                t("Author")
            ];
            let items_to_csv = [];
            let i = 0;
            for (i in items) {
                items_to_csv.push({
                    local_unit: items[i].local_unit,
                    local_line: items[i].local_line,
                    local_machine: items[i].local_machine,
                    local_name: items[i].local_name,
                    model_name: items[i].model_name,
                    device_name: items[i].device_name,
                    uuid: items[i].uuid,
                    device_description: items[i].device_description,
                    device_address: items[i].device_address,
                    device_eui: items[i].device_eui,
                    last_status: items[i].last_status,
                    measure_interval: items[i].measure_interval,
                    date_created: new Date(items[i].date_created).toLocaleString('fi-FI'),
                    settings_last_modified_time: items[i].settings_last_modified_time ? new Date(items[i].settings_last_modified_time).toLocaleString('fi-FI') : "",
                    settings_last_modified_author: items[i].settings_last_modified_author.username
                    // last_modified: new Date(items[i].last_modified).toLocaleString('fi-FI'),
                    // author: items[i].author.username
                });
            }
            exportToCsv(this.props.activeCompanyId, "export", titles, items_to_csv);
        }
    };

    checkIfOnlyCustomerRole = (roles) => {
        // Only Client role activated to limit access
        if (roles && roles.length === 1 && roles.includes("C")) {
            return true;
        }
        return false;
    };

    handleViewModeChange = (mode) => {
        localStorage.setItem("sensorViewMode", mode);
        this.setState({
            viewMode: mode,
            selectedSensorIds: new Set(),
            selectAll: false
        });
    };

    getGroupDisplayName = (name) => {
        const logo = localStorage.getItem("Logo");
        if (logo === "Polygon" && name === "Default group") return "TMP VARASTO";
        return name;
    };

    getSortedSensorGroups = (groups) => {
        // Default group always first, rest alphabetically (fi locale)
        return (groups || []).slice().sort((a, b) => {
            if (a.name === "Default group") return -1;
            if (b.name === "Default group") return 1;
            return (a.name || "").localeCompare(b.name || "", "fi");
        });
    };

    getFlatSensorList = () => {
        const { sensor_groups } = this.state;
        if (!sensor_groups) return [];
        let allSensors = [];
        sensor_groups.forEach(group => {
            group.sensors.forEach(sensor => {
                allSensors.push({
                    ...sensor,
                    sensor_group_name: this.getGroupDisplayName(group.name),
                    sensor_group_id: group.id
                });
            });
        });
        return allSensors;
    };

    getTableFilteredSensors = (sensors) => {
        const { t } = this.props;
        const { activeMenuItem, tableGroupFilter } = this.state;
        let filtered = sensors;
        if (activeMenuItem === t("Active")) {
            filtered = filtered.filter(s => s.is_active);
        } else if (activeMenuItem === t("Archive")) {
            filtered = filtered.filter(s => !s.is_active);
        }
        if (tableGroupFilter && tableGroupFilter !== "all") {
            filtered = filtered.filter(s => s.sensor_group_id === tableGroupFilter);
        }
        return this.handleGetTableFilterList(filtered);
    };

    handleSort = (clickedColumn) => {
        const { sortColumn, sortDirection } = this.state;
        if (sortColumn !== clickedColumn) {
            this.setState({ sortColumn: clickedColumn, sortDirection: "ascending" });
        } else {
            this.setState({
                sortDirection: sortDirection === "ascending" ? "descending" : "ascending"
            });
        }
    };

    getSortedSensors = (sensors) => {
        const { sortColumn, sortDirection } = this.state;
        if (!sortColumn) return sensors;
        const sorted = [...sensors].sort((a, b) => {
            let valA, valB;
            switch (sortColumn) {
                case "model":
                    valA = a.device_name; valB = b.device_name; break;
                case "location":
                    valA = `${a.local_unit} ${a.local_line} ${a.local_machine} ${a.local_name}`;
                    valB = `${b.local_unit} ${b.local_line} ${b.local_machine} ${b.local_name}`;
                    break;
                case "lastValue":
                    valA = a.last_display_value; valB = b.last_display_value; break;
                case "group":
                    valA = a.sensor_group_name; valB = b.sensor_group_name; break;
                case "active":
                    valA = a.is_active ? "1" : "0"; valB = b.is_active ? "1" : "0"; break;
                default:
                    valA = ""; valB = "";
            }
            valA = (valA || "").toString().toLowerCase();
            valB = (valB || "").toString().toLowerCase();
            return valA.localeCompare(valB, 'fi');
        });
        if (sortDirection === "descending") sorted.reverse();
        return sorted;
    };

    handleToggleSensor = (sensorId) => {
        this.setState(prevState => {
            const selected = new Set(prevState.selectedSensorIds);
            if (selected.has(sensorId)) {
                selected.delete(sensorId);
            } else {
                selected.add(sensorId);
            }
            return { selectedSensorIds: selected, selectAll: false };
        });
    };

    handleSelectAll = (visibleSensorIds) => {
        this.setState(prevState => {
            if (prevState.selectAll) {
                return { selectedSensorIds: new Set(), selectAll: false };
            } else {
                return { selectedSensorIds: new Set(visibleSensorIds), selectAll: true };
            }
        });
    };

    handleBulkUpdate = (updatedItems) => {
        this.setState({ bulkActionLoading: true });
        const { activeCompanyId } = this.props;
        const sensorIds = Array.from(this.state.selectedSensorIds);
        authAxios
            .post(sensorsUpdateMultipleURL(activeCompanyId), {
                sensor_ids: sensorIds,
                updated_items: updatedItems
            })
            .then(res => {
                this.setState({
                    selectedSensorIds: new Set(),
                    selectAll: false,
                    bulkActionLoading: false,
                    bulk_confirm_open: false,
                    bulkAction: null,
                    bulkMoveGroupId: null,
                    bulkAddress: "",
                    bulkPostalCode: "",
                    bulkCity: "",
                    bulkCountry: "",
                    bulkLatitude: "",
                    bulkLongitude: "",
                    success_mgs: this.props.t("Update successful")
                });
                this.handleFetchGroupList();
            })
            .catch(err => {
                this.setState({ error: err, bulkActionLoading: false });
            });
    };

    handleBulkDelete = () => {
        this.setState({ bulkActionLoading: true });
        const { activeCompanyId } = this.props;
        const sensorIds = Array.from(this.state.selectedSensorIds);
        authAxios
            .post(sensorsDeleteMultipleURL(activeCompanyId), {
                sensor_ids: sensorIds
            })
            .then(res => {
                this.setState({
                    selectedSensorIds: new Set(),
                    selectAll: false,
                    bulkActionLoading: false,
                    bulkAction: null,
                    bulk_confirm_open: false
                });
                this.handleFetchGroupList();
            })
            .catch(err => {
                this.setState({ error: err, bulkActionLoading: false });
            });
    };

    handleBulkMoveToCompany = () => {
        this.setState({ bulkActionLoading: true });
        const { activeCompanyId } = this.props;
        const { bulkMoveCompanyId, selectedSensorIds } = this.state;
        authAxios
            .post(sensorMoveToOtherCompanyURL(activeCompanyId, bulkMoveCompanyId), {
                sensor_ids: Array.from(selectedSensorIds)
            })
            .then(res => {
                this.setState({
                    selectedSensorIds: new Set(),
                    selectAll: false,
                    bulkActionLoading: false,
                    bulkAction: null,
                    bulk_confirm_open: false,
                    bulkMoveCompanyId: null
                });
                this.handleFetchGroupList();
            })
            .catch(err => {
                this.setState({ error: err, bulkActionLoading: false });
            });
    };

    handleBulkAddressPlaceSelected = (placeData) => {
        this.setState({
            bulkAddress: placeData.address,
            bulkPostalCode: placeData.postal_code,
            bulkCity: placeData.city,
            bulkCountry: placeData.country,
            bulkLatitude: placeData.latitude.toString(),
            bulkLongitude: placeData.longitude.toString()
        });
    };

    handleBulkAddressGeocode = (coords) => {
        this.setState({
            bulkLatitude: coords.latitude.toString(),
            bulkLongitude: coords.longitude.toString()
        });
    };

    renderBulkActionBar = () => {
        const { selectedSensorIds, bulkMoveGroupId, bulkMoveCompanyId, bulkActionLoading, bulkAction, activeMenuItem,
            bulkAddress, bulkPostalCode, bulkCity, bulkCountry, bulkLatitude, bulkLongitude } = this.state;
        const { t, userCompanies } = this.props;
        const logo = localStorage.getItem("Logo");
        const count = selectedSensorIds.size;
        if (count === 0) return null;

        const groupOptions = this.getSortedSensorGroups(this.state.sensor_groups).map(g => ({
            key: g.id, text: this.getGroupDisplayName(g.name), value: g.id
        }));
        const companyOptions = (userCompanies || [])
            .filter(c => c.id !== this.props.activeCompanyId)
            .slice()
            .sort((a, b) => (a.name || "").localeCompare(b.name || "", "fi"))
            .map(c => ({
                key: c.id, text: c.name, value: c.id
            }));

        let actionOptions = [
            { key: "moveGroup", text: logo === "Polygon" ? t("Move to target") : t("Move to group"), value: "moveGroup" },
            { key: "moveCompany", text: t("Move to company"), value: "moveCompany" },
            { key: "editAddress", text: t("Edit address"), value: "editAddress" },
            { key: "clearAddress", text: t("Clear address"), value: "clearAddress" },
            { key: "archive", text: t("Archive"), value: "archive" },
            { key: "activate", text: t("Activate"), value: "activate" }
        ];
        const { activeRoles } = this.props;
        const hasAdminRole = activeRoles && (activeRoles.includes("A") || activeRoles.includes("S"));
        if (companyOptions.length === 0 || !hasAdminRole) {
            actionOptions = actionOptions.filter(o => o.value !== "moveCompany");
        }
        if (!hasAdminRole) {
            actionOptions = actionOptions.filter(o => o.value !== "archive" && o.value !== "activate");
        }
        if (activeMenuItem === t("Archive") && hasAdminRole) {
            actionOptions.push({ key: "delete", text: t("Delete"), value: "delete" });
        }

        return (
            <Segment>
                <b>{count} {t("selected")}</b>
                <Select
                    placeholder={t("Select action")}
                    options={actionOptions}
                    onChange={(e, {value}) => this.setState({
                        bulkAction: value,
                        bulkMoveGroupId: null,
                        bulkMoveCompanyId: null,
                        bulkAddress: "",
                        bulkPostalCode: "",
                        bulkCity: "",
                        bulkCountry: "",
                        bulkLatitude: "",
                        bulkLongitude: ""
                    })}
                    value={bulkAction || ""}
                    style={{marginLeft: 15, minWidth: 180}}
                />

                {bulkAction === "moveGroup" && (
                    <span style={{marginLeft: 10}}>
                        <Select
                            placeholder={logo === "Polygon" ? t("Select target") : t("Select group")}
                            options={groupOptions}
                            onChange={(e, {value}) => this.setState({bulkMoveGroupId: value})}
                            value={bulkMoveGroupId || ""}
                            style={{marginRight: 5, minWidth: 150}}
                            search
                        />
                        <Button size="small" primary
                            loading={bulkActionLoading}
                            disabled={!bulkMoveGroupId || bulkActionLoading}
                            onClick={() => this.handleBulkUpdate({sensor_group: bulkMoveGroupId})}>
                            {t("OK")}
                        </Button>
                    </span>
                )}

                {bulkAction === "moveCompany" && (
                    <span style={{marginLeft: 10}}>
                        <Select
                            placeholder={t("Select company")}
                            options={companyOptions}
                            onChange={(e, {value}) => this.setState({bulkMoveCompanyId: value})}
                            value={bulkMoveCompanyId || ""}
                            style={{marginRight: 5, minWidth: 150}}
                            search
                        />
                        <Button size="small" primary
                            loading={bulkActionLoading}
                            disabled={!bulkMoveCompanyId || bulkActionLoading}
                            onClick={() => this.setState({
                                bulk_confirm_open: true,
                                bulk_confirm_text: t("Are you sure you want to move sensors to another company", {count}),
                                bulk_confirm_action: "moveCompany"
                            })}>
                            {t("OK")}
                        </Button>
                    </span>
                )}

                {bulkAction === "editAddress" && (
                    <div style={{marginTop: 10}}>
                        <Grid>
                            <Grid.Row>
                                <Grid.Column width={8}>
                                    <label><b>{t("Address")}</b></label>
                                    <AddressAutocomplete
                                        value={bulkAddress}
                                        name="bulkAddress"
                                        onChange={(e) => this.setState({bulkAddress: e.target.value})}
                                        onPlaceSelected={this.handleBulkAddressPlaceSelected}
                                        onGeocode={this.handleBulkAddressGeocode}
                                        address={bulkAddress}
                                        postalCode={bulkPostalCode}
                                        city={bulkCity}
                                        t={t}
                                        showGeocodeButton={true}
                                    />
                                </Grid.Column>
                                <Grid.Column width={3}>
                                    <label><b>{t("Postal code")}</b></label>
                                    <Input
                                        fluid
                                        value={bulkPostalCode}
                                        onChange={(e) => this.setState({bulkPostalCode: e.target.value})}
                                    />
                                </Grid.Column>
                                <Grid.Column width={5}>
                                    <label><b>{t("City")}</b></label>
                                    <Input
                                        fluid
                                        value={bulkCity}
                                        onChange={(e) => this.setState({bulkCity: e.target.value})}
                                    />
                                </Grid.Column>
                            </Grid.Row>
                            <Grid.Row>
                                <Grid.Column width={3}>
                                    <label><b>{t("Latitude")}</b></label>
                                    <Input
                                        fluid
                                        value={bulkLatitude}
                                        onChange={(e) => this.setState({bulkLatitude: e.target.value})}
                                    />
                                </Grid.Column>
                                <Grid.Column width={3}>
                                    <label><b>{t("Longitude")}</b></label>
                                    <Input
                                        fluid
                                        value={bulkLongitude}
                                        onChange={(e) => this.setState({bulkLongitude: e.target.value})}
                                    />
                                </Grid.Column>
                                <Grid.Column width={4} verticalAlign="bottom">
                                    <Button size="small" primary
                                        loading={bulkActionLoading}
                                        disabled={!bulkAddress || bulkActionLoading}
                                        onClick={() => {
                                            const updated = {
                                                device_location_address: bulkAddress,
                                                device_location_postal_code: bulkPostalCode,
                                                device_location_city: bulkCity,
                                                ...(bulkCountry ? {device_location_country: bulkCountry} : {}),
                                                ...(bulkLatitude ? {device_location_latitude: bulkLatitude} : {}),
                                                ...(bulkLongitude ? {device_location_longitude: bulkLongitude} : {})
                                            };
                                            this.handleBulkUpdate(updated);
                                        }}>
                                        {t("OK")}
                                    </Button>
                                </Grid.Column>
                            </Grid.Row>
                        </Grid>
                    </div>
                )}

                {bulkAction === "clearAddress" && (
                    <Button size="small" primary style={{marginLeft: 10}}
                        loading={bulkActionLoading}
                        disabled={bulkActionLoading}
                        onClick={() => this.setState({
                            bulk_confirm_open: true,
                            bulk_confirm_text: t("Are you sure you want to clear address from selected sensors", {count}),
                            bulk_confirm_action: "clearAddress"
                        })}>
                        {t("OK")}
                    </Button>
                )}

                {bulkAction === "archive" && (
                    <Button size="small" primary style={{marginLeft: 10}}
                        loading={bulkActionLoading}
                        disabled={bulkActionLoading}
                        onClick={() => this.handleBulkUpdate({is_active: false})}>
                        {t("OK")}
                    </Button>
                )}

                {bulkAction === "activate" && (
                    <Button size="small" primary style={{marginLeft: 10}}
                        loading={bulkActionLoading}
                        disabled={bulkActionLoading}
                        onClick={() => this.handleBulkUpdate({is_active: true})}>
                        {t("OK")}
                    </Button>
                )}

                {bulkAction === "delete" && (
                    <Button size="small" color="red" style={{marginLeft: 10}}
                        loading={bulkActionLoading}
                        disabled={bulkActionLoading}
                        onClick={() => this.setState({
                            bulk_confirm_open: true,
                            bulk_confirm_text: t("Are you sure you want to delete selected sensors", {count}),
                            bulk_confirm_action: "delete"
                        })}>
                        {t("OK")}
                    </Button>
                )}
            </Segment>
        );
    };

    renderTableView = () => {
        const { t, activeRoles } = this.props;
        const { selectedSensorIds, selectAll, sortColumn, sortDirection, activeMenuItem, tableGroupFilter } = this.state;
        const logo = localStorage.getItem("Logo");
        const is_desktop = getWidth() > Responsive.onlyMobile.maxWidth;
        const showBulkActions = !this.checkIfOnlyCustomerRole(activeRoles);

        const allSensors = this.getFlatSensorList();
        const filtered = this.getTableFilteredSensors(allSensors);
        const sorted = this.getSortedSensors(filtered);
        const visibleIds = sorted.map(s => s.id);

        const groupFilterOptions = [
            { key: "all", text: logo === "Polygon" ? t("All targets") : t("All groups"), value: "all" },
            ...this.getSortedSensorGroups(this.state.sensor_groups).map(g => ({
                key: g.id, text: this.getGroupDisplayName(g.name), value: g.id
            }))
        ];

        return (
            <React.Fragment>
                <Menu attached="top" tabular>
                    <Menu.Item
                        name={t("Active")}
                        active={activeMenuItem === t("Active")}
                        onClick={(e, { name }) => this.setState({
                            activeMenuItem: name,
                            selectedSensorIds: new Set(), selectAll: false
                        })} />
                    <Menu.Item
                        name={t("Archive")}
                        active={activeMenuItem === t("Archive")}
                        onClick={(e, { name }) => this.setState({
                            activeMenuItem: name,
                            selectedSensorIds: new Set(), selectAll: false
                        })} />
                </Menu>
                <Segment attached>
                    <Select
                        placeholder={logo === "Polygon" ? t("All targets") : t("All groups")}
                        options={groupFilterOptions}
                        onChange={(e, {value}) => {
                            const groupFilter = value || "all";
                            localStorage.setItem("sensorTableGroupFilter", JSON.stringify(groupFilter));
                            this.setState({
                                tableGroupFilter: groupFilter,
                                selectedSensorIds: new Set(), selectAll: false
                            });
                        }}
                        value={tableGroupFilter || "all"}
                        style={{minWidth: 150}}
                        search
                    />
                    {(() => {
                        if (!tableGroupFilter || tableGroupFilter === "all") return null;
                        const selectedGroup = (this.state.sensor_groups || []).find(g => g.id === tableGroupFilter);
                        if (!selectedGroup) return null;
                        const addressParts = [
                            selectedGroup.location_address,
                            selectedGroup.location_postal_code,
                            selectedGroup.location_city
                        ].filter(p => p);
                        return (
                            <Link
                                to={`/sensor/sensor-group-details/${selectedGroup.id}/`}
                                style={{ marginLeft: 20 }}
                            >
                                <b>{this.getGroupDisplayName(selectedGroup.name)}</b>
                                {selectedGroup.description && <> — {selectedGroup.description}</>}
                                {addressParts.length > 0 && <> — {addressParts.join(", ")}</>}
                            </Link>
                        );
                    })()}
                </Segment>
                {showBulkActions && this.renderBulkActionBar()}
                <Table sortable striped selectable celled>
                    {is_desktop && (
                        <Table.Header>
                            <Table.Row>
                                {showBulkActions && (
                                    <Table.HeaderCell collapsing>
                                        <Checkbox
                                            checked={selectAll}
                                            onChange={() => this.handleSelectAll(visibleIds)}
                                        />
                                    </Table.HeaderCell>
                                )}
                                <Table.HeaderCell
                                    width="3"
                                    sorted={sortColumn === "model" ? sortDirection : null}
                                    onClick={() => this.handleSort("model")}>
                                    {logo === "Polygon" ? t("Anturinimi / Sarjanro.") : t("Model and address")}
                                </Table.HeaderCell>
                                <Table.HeaderCell
                                    width="3"
                                    sorted={sortColumn === "location" ? sortDirection : null}
                                    onClick={() => this.handleSort("location")}>
                                    {logo === "Polygon" ? t("Kohde / Sijainti") : t("Local machine")}
                                </Table.HeaderCell>
                                <Table.HeaderCell
                                    width="3"
                                    sorted={sortColumn === "lastValue" ? sortDirection : null}
                                    onClick={() => this.handleSort("lastValue")}>
                                    {logo === "Polygon" ? t("Viimeisin mittausarvo") : t("Last status")}
                                </Table.HeaderCell>
                                <Table.HeaderCell collapsing textAlign="center">{t("Status")}</Table.HeaderCell>
                                <Table.HeaderCell collapsing textAlign="center">{t("Alarms")}</Table.HeaderCell>
                                <Table.HeaderCell collapsing textAlign="center">{t("Signal")}</Table.HeaderCell>
                                <Table.HeaderCell
                                    width="2"
                                    sorted={sortColumn === "group" ? sortDirection : null}
                                    onClick={() => this.handleSort("group")}>
                                    {logo === "Polygon" ? t("Target") : t("Sensor group")}
                                </Table.HeaderCell>
                                <Table.HeaderCell
                                    collapsing
                                    textAlign="center"
                                    sorted={sortColumn === "active" ? sortDirection : null}
                                    onClick={() => this.handleSort("active")}>
                                    {t("Active")}
                                </Table.HeaderCell>
                            </Table.Row>
                        </Table.Header>
                    )}
                    <Table.Body>
                        {sorted.map((sensor) => {
                            let _last_display_value = sensor.last_display_value;
                            if (_last_display_value !== "") {
                                _last_display_value = _last_display_value.replace("\\n", "\n");
                                _last_display_value = _last_display_value.replace("\\n", "\n");
                            }
                            return (
                                <Table.Row key={sensor.id}>
                                    {showBulkActions && (
                                        <Table.Cell collapsing>
                                            <Checkbox
                                                checked={selectedSensorIds.has(sensor.id)}
                                                onChange={() => this.handleToggleSensor(sensor.id)}
                                            />
                                        </Table.Cell>
                                    )}
                                    <Table.Cell onClick={() => this.openSensorDetails(sensor)}>
                                        {!is_desktop && (<React.Fragment><b>{t("Model and address")}</b><br/></React.Fragment>)}
                                        <Header as="h5">
                                            {sensor.device_name}
                                            <Header sub>{sensor.device_eui}</Header>
                                        </Header>
                                    </Table.Cell>
                                    <Table.Cell onClick={() => this.openSensorDetails(sensor)}>
                                        {!is_desktop && (<React.Fragment><b>{t("Local machine")}</b><br/></React.Fragment>)}
                                        {sensor.local_unit}
                                        {sensor.local_unit ? (`/${sensor.local_line}`) : (sensor.local_line)}
                                        {sensor.local_line ? (`/${sensor.local_machine}`) : (sensor.local_machine)}
                                        {sensor.local_machine ? (`/${sensor.local_name}`) : (sensor.local_name)}
                                        {sensor.device_location_address && (
                                            <>
                                                <br/>
                                                <Header sub>
                                                    {sensor.device_location_address} {sensor.device_location_address && ","} {sensor.device_location_postal_code} {sensor.device_location_city}
                                                </Header>
                                            </>
                                        )}
                                    </Table.Cell>
                                    <Table.Cell onClick={() => this.openSensorDetails(sensor)}>
                                        {!is_desktop && (<React.Fragment><b>{t("Last status")}</b><br/></React.Fragment>)}
                                        {(logo === "Polygon" && sensor.sensor_model.model_name.startsWith("CAPROC-TH-PROBE-3")) ? (
                                            <Header as="h5">{this.handleLastStatusDisplay(sensor,1)}<br/>{this.handleLastStatusDisplay(sensor,2)}<br/>{this.handleLastStatusDisplay(sensor,3)}</Header>
                                        ) : (
                                            <Header as="h5">{_last_display_value} <br/></Header>
                                        )}
                                        {sensor.last_status ? (new Date(sensor.last_status).toLocaleString('fi-FI')) : ("")}
                                    </Table.Cell>
                                    {this.handleGetStatus(sensor)}
                                    {this.handleGetAlarmsStatus(sensor)}
                                    {this.renderSignalCell(sensor)}
                                    <Table.Cell onClick={() => this.openSensorDetails(sensor)}>
                                        {!is_desktop && (<React.Fragment><b>{logo === "Polygon" ? t("Target") : t("Sensor group")}</b><br/></React.Fragment>)}
                                        {sensor.sensor_group_name}
                                    </Table.Cell>
                                    <Table.Cell collapsing textAlign="center">
                                        {sensor.is_active ? (
                                            <Icon name="check" color="green" />
                                        ) : (
                                            <Icon name="archive" color="grey" />
                                        )}
                                    </Table.Cell>
                                </Table.Row>
                            );
                        })}
                    </Table.Body>
                </Table>
                <Confirm
                    content={this.state.bulk_confirm_text}
                    open={this.state.bulk_confirm_open}
                    onCancel={() => this.setState({bulk_confirm_open: false})}
                    onConfirm={() => {
                        if (this.state.bulk_confirm_action === "delete") this.handleBulkDelete();
                        else if (this.state.bulk_confirm_action === "moveCompany") this.handleBulkMoveToCompany();
                        else if (this.state.bulk_confirm_action === "clearAddress") this.handleBulkUpdate({
                            device_location_address: "",
                            device_location_postal_code: "",
                            device_location_city: "",
                            device_location_country: "",
                            device_location_latitude: 0,
                            device_location_longitude: 0
                        });
                    }}
                />
            </React.Fragment>
        );
    };

    render() {
        const { error, loading, sensor_groups, activeMenuItem, delete_confirm_open, delete_confirm_text, delete_item, search, viewMode } = this.state;
        const { isAuthenticated, t, activeRoles } = this.props;
        if (!isAuthenticated) {
            return <Redirect to="/login" />;
        }
        const is_desktop =  getWidth() > Responsive.onlyMobile.maxWidth ? true : false;
        //console.log(this.state);
        const logo = localStorage.getItem("Logo");
        return (
            <Shell is_desktop={is_desktop}>
                {(logo && activeRoles) && (
                    <>
                        {(sensor_groups && is_desktop) && (
                            <>
                                <Button.Group floated="right" basic size='small' style={{marginLeft: 5}}>
                                    <Button icon="list" active={viewMode === "grouped"} onClick={() => this.handleViewModeChange("grouped")} title={t("Grouped view")} />
                                    <Button icon="table" active={viewMode === "table"} onClick={() => this.handleViewModeChange("table")} title={t("Table view")} />
                                </Button.Group>
                                <Button.Group floated="right" basic size='small'>
                                    <Button icon="download" content="CSV" onClick={() => this.handleExportToCSV(this.handleGetFilterListToExport(sensor_groups))} />
                                </Button.Group>
                            </>
                        )}
                        {logo === "Polygon" ? (
                            <Header as="h3">{t("Kohteet/Anturit")}</Header>
                        ) : (
                            <Header as="h3">{t("Sensors")}</Header>
                        )}
                        
                        {(this.props.activeRoles && this.props.activeRoles.includes("A")) && (
                            <Link to="/sensor/sensor-details/create/">
                                <Button floated="right" color="green">
                                    {t("+ Sensor")}
                                </Button>
                            </Link>
                        )}
                        <Input
                            floated="right"
                            size="mini"
                            icon='search'
                            value={search}
                            name="search"
                            onChange={this.handleChange} />
                        {error && (
                            <Message
                                error
                                header={t("There was an error")}
                                content={JSON.stringify(error)}
                            />
                        )}
                        {loading && (
                            <Segment>
                                <Dimmer active inverted>
                                    <Loader inverted>Loading</Loader>
                                </Dimmer>
                                <Image src="https://react.semantic-ui.com/images/wireframe/short-paragraph.png" />
                            </Segment>
                        )}

                        {sensor_groups && viewMode === "table" && (
                            this.renderTableView()
                        )}

                        {sensor_groups && viewMode !== "table" && (
                            <React.Fragment>
                                <Menu attached="top" tabular>
                                    <Menu.Item
                                        name={t("Active")}
                                        active={activeMenuItem === t("Active")}
                                        onClick={this.handleMenuItemClick} />
                                    <Menu.Item
                                        name={t("Archive")}
                                        active={activeMenuItem === t("Archive")}
                                        onClick={this.handleMenuItemClick} />
                                </Menu>

                                {this.getSortedSensorGroups(sensor_groups).map((sensor_group) => {
                                    return (
                                        <React.Fragment key={sensor_group.id}>
                                            <div>

                                                {sensor_group.sensors.length > 0 && (
                                                    <React.Fragment>
                                                        <br></br>
                                                        <Grid columns="2">
                                                            <Grid.Column>
                                                            {!this.checkIfOnlyCustomerRole(activeRoles) ? (
                                                                <Link to={`/sensor/sensor-group-details/${sensor_group.id}/`}>
                                                                    {(logo === "Polygon" && sensor_group.name === "Default group") ? (
                                                                        <Header as="h4" color="blue">
                                                                            {t("TMP VARASTO")}
                                                                        </Header>
                                                                    ) : (
                                                                        <Header as="h4" color="blue">
                                                                            {sensor_group.name} {sensor_group.display_value !== "" ? (`: ${sensor_group.display_value}`) : ""}
                                                                        </Header>
                                                                    )}
                                                                </Link>
                                                            ) : (
                                                                <>
                                                                    {(logo === "Polygon" && sensor_group.name === "Default group") ? (
                                                                        <Header as="h4" color="blue">
                                                                            {t("TMP VARASTO")}
                                                                        </Header>
                                                                    ) : (
                                                                        <Header as="h4" color="blue">
                                                                            {sensor_group.name} {sensor_group.display_value !== "" ? (`: ${sensor_group.display_value}`) : ""}
                                                                        </Header>
                                                                    )}
                                                                </>
                                                            )}
                                                            </Grid.Column>
                                                            {!this.checkIfOnlyCustomerRole(activeRoles) && (
                                                                <Grid.Column textAlign="right">
                                                                    {sensor_group.alarm_notification_status === "A" && (
                                                                        <Button positive content={t(sensor_group.alarm_notification_status_display)} onClick={() => this.handleGroupNotificationChange(sensor_group.id)}/>
                                                                    )}
                                                                    {sensor_group.alarm_notification_status === "E" && (
                                                                        <Button primary content={t(sensor_group.alarm_notification_status_display)} onClick={() => this.handleGroupNotificationChange(sensor_group.id)}/>
                                                                    )}
                                                                    {sensor_group.alarm_notification_status === "S" && (
                                                                        <Button color="orange" content={t(sensor_group.alarm_notification_status_display)} onClick={() => this.handleGroupNotificationChange(sensor_group.id)}/>
                                                                    )}
                                                                    {sensor_group.alarm_notification_status === "O" && (
                                                                        <Button negative content={t(sensor_group.alarm_notification_status_display)} onClick={() => this.handleGroupNotificationChange(sensor_group.id)}/>
                                                                    )}
                                                                </Grid.Column>
                                                            )}
                                                        </Grid>
                                                        <Table striped selectable celled >
                                                            {is_desktop && (
                                                                <Table.Header>
                                                                    <Table.Row>
                                                                        <Table.HeaderCell width="1"/>
                                                                        {logo === "Polygon" ? (
                                                                            <>
                                                                                <Table.HeaderCell width="4">{t("Anturinimi / Sarjanro.")}</Table.HeaderCell>
                                                                                {/* <Table.HeaderCell collapsing>{t("Address")}</Table.HeaderCell> */}
                                                                                <Table.HeaderCell width="4">{t("Kohde / Sijainti")}</Table.HeaderCell>
                                                                                {/* <Table.HeaderCell >{t("Local name")}</Table.HeaderCell> */}
                                                                                <Table.HeaderCell width="5">{t("Viimeisin mittausarvo")}</Table.HeaderCell>
                                                                                <Table.HeaderCell width="1">{t("Status")}</Table.HeaderCell>
                                                                                <Table.HeaderCell width="1">{t("Alarms")}</Table.HeaderCell>
                                                                                <Table.HeaderCell width="1">{t("Signal")}</Table.HeaderCell>
                                                                                {activeMenuItem === t("Archive") && (
                                                                                    <Table.HeaderCell />
                                                                                )}
                                                                            </>
                                                                        ) : (
                                                                            <>
                                                                                <Table.HeaderCell width="4">{t("Model and address")}</Table.HeaderCell>
                                                                                {/* <Table.HeaderCell collapsing>{t("Address")}</Table.HeaderCell> */}
                                                                                <Table.HeaderCell width="5">{t("Local machine")}</Table.HeaderCell>
                                                                                {/* <Table.HeaderCell >{t("Local name")}</Table.HeaderCell> */}
                                                                                <Table.HeaderCell width="4">{t("Last status")}</Table.HeaderCell>
                                                                                <Table.HeaderCell width="1">{t("Status")}</Table.HeaderCell>
                                                                                <Table.HeaderCell width="1">{t("Alarms")}</Table.HeaderCell>
                                                                                <Table.HeaderCell width="1">{t("Signal")}</Table.HeaderCell>
                                                                                {activeMenuItem === t("Archive") && (
                                                                                    <Table.HeaderCell />
                                                                                )}
                                                                            </>
                                                                        )}
                                                                        
                                                                    </Table.Row>
                                                                </Table.Header>
                                                            )}
                                                            <Table.Body>
                                                                {this.handleGetFilterList(sensor_group.sensors).map((sensor) => {
                                                                    if ((activeMenuItem === t("Active") && sensor.is_active) || (activeMenuItem === t("Archive") && !sensor.is_active)) {
                                                                        let _last_display_value = sensor.last_display_value;
                                                                        if (_last_display_value !== "")
                                                                        {
                                                                            _last_display_value = _last_display_value.replace("\\n", "\n");
                                                                            _last_display_value = _last_display_value.replace("\\n", "\n");
                                                                        }
                                                                        return (
                                                                            <Table.Row key={sensor.id}>
                                                                                <Table.Cell  onClick={() => this.openSensorDetails(sensor)}>
                                                                                <Image src={sensor.sensor_model.thumbnail_image_url} size="mini"/>
                                                                                </Table.Cell>
                                                                                
                                                                                <Table.Cell  onClick={() => this.openSensorDetails(sensor)}>
                                                                                    {!is_desktop && (<React.Fragment><b>{t("Model and address")}</b><br/></React.Fragment>)}
                                                                                    
                                                                                    <Header as="h5">
                                                                                        {sensor.device_name}
                                                                                        <Header sub>{sensor.device_eui}</Header>
                                                                                    </Header>
                                                                                </Table.Cell>
                                                                                {/* <Table.Cell  onClick={() => this.openSensorDetails(sensor)}>
                                                                                    {!is_desktop && (<React.Fragment><b>{t("Local machine")}</b><br/></React.Fragment>)}
                                                                                    {sensor.local_machine}
                                                                                </Table.Cell> */}
                                                                                <Table.Cell  onClick={() => this.openSensorDetails(sensor)}>
                                                                                    {!is_desktop && (<React.Fragment><b>{t("Local machine")}</b><br/></React.Fragment>)}
                                                                                    {sensor.local_unit} 
                                                                                    {sensor.local_unit ? (`/${sensor.local_line}`) : (sensor.local_line)} 
                                                                                    {sensor.local_line ? (`/${sensor.local_machine}`) : (sensor.local_machine)}
                                                                                    {sensor.local_machine ? (`/${sensor.local_name}`) : (sensor.local_name)} 
                                                                                    {sensor.device_location_address && (
                                                                                    <>
                                                                                        <br/>
                                                                                        <Header sub>
                                                                                            {sensor.device_location_address} {sensor.device_location_address && ","} {sensor.device_location_postal_code} {sensor.device_location_city}
                                                                                        </Header>
                                                                                    </>
                                                                                    )}
                                                                                </Table.Cell>
                                                                                {/* <Table.Cell  onClick={() => this.openSensorDetails(sensor)}>
                                                                                    {!is_desktop && (<React.Fragment><b>{t("Local name")}</b><br/></React.Fragment>)}
                                                                                    {sensor.local_name}
                                                                                </Table.Cell> */}
                                                                                {/* <Table.Cell collapsing onClick={() => this.openSensorDetails(sensor)}>
                                                                                    {!is_desktop && (<React.Fragment><b>{t("Address")}</b><br/></React.Fragment>)}
                                                                                    {sensor.device_address}
                                                                                </Table.Cell> */}
                                                                                <Table.Cell  onClick={() => this.openSensorDetails(sensor)}>
                                                                                    {!is_desktop && (<React.Fragment><b>{t("Last status")}</b><br/></React.Fragment>)}
                                                                                    {(logo === "Polygon" && sensor.sensor_model.model_name.startsWith("CAPROC-TH-PROBE-3")) ? (
                                                                                        <>
                                                                                            <Header as="h5">{this.handleLastStatusDisplay(sensor,1)}<br/>{this.handleLastStatusDisplay(sensor,2)}<br/>{this.handleLastStatusDisplay(sensor,3)}</Header>
                                                                                            {/* <Header as="h5">{this.handleLastStatusDisplay(sensor,2)}</Header>
                                                                                            <Header as="h5">{this.handleLastStatusDisplay(sensor,3)}</Header> */}
                                                                                        </>
                                                                                    ) : (
                                                                                        <Header as="h5">{_last_display_value} <br/></Header>
                                                                                    )}
                                                                                    {sensor.last_status ? (new Date(sensor.last_status).toLocaleString('fi-FI')) : ("")}
                                                                                </Table.Cell>
                                                                                {this.handleGetStatus(sensor)}
                                                                                {this.handleGetAlarmsStatus(sensor)}
                                                                                {this.renderSignalCell(sensor)}
                                                                                {activeMenuItem === t("Archive") && (
                                                                                    <Table.Cell  textAlign='center'><Icon link color="red"  name='trash alternate outline'
                                                                                        onClick={() => this.openDeleteConfirm(t("Are you sure your want to delete", { sensor_name: sensor.local_name }), sensor.id)} /></Table.Cell>
                                                                                )}
                                                                            </Table.Row>
                                                                        );
                                                                    }
                                                                    return null;
                                                                })}
                                                            </Table.Body>
                                                        </Table>
                                                    </React.Fragment>
                                                )}

                                            </div>
                                        </React.Fragment>
                                    );
                                })}
                                <Confirm
                                    content={delete_confirm_text}
                                    open={delete_confirm_open}
                                    onCancel={() => this.closeDeleteConfirm()}
                                    onConfirm={() => this.handleDeleteSensor(delete_item)}
                                />

                            </React.Fragment>
                        )}
                    </>
                )}
            </Shell>
        );
    }
}
const mapStateToProps = state => {
    return {
        activeCompanyId: state.company.activeCompanyId,
        isAuthenticated: state.auth.token !== null,
        activeRoles: state.company.activeRoles,
        userCompanies: state.company.userCompanies
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setActivity: () => dispatch(setActivity())
    };
};

export default withRouter(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(withTranslation('sensors')(Sensors))
);